// TODO: revoke API secrets and replace with environment configuration
export const DONACO_MERCHANT_ID = process.env.PAYPAL_MERCHANT_ID;

// the referral return URL is used to redirect the charity back to the Donaco dashboard
// once the PayPal onboarding is complete.
// PayPal appends parameters to this URL, relating to the completed onboarding.
// The URL is configured using the dashboard window URL (so it can be localhost when debugging)
export const PARTNER_REFERRAL_RETURN_URL = `${window.location.origin}/payments`;
